// 文件上传助手

const upload = {
    
    // 获取上传路径
    
    getUploadWay: function (fileProps, handle, instance) {
        const baseURL = instance.$axios.defaults.baseURL;
        instance.$axios({
            url: '/xhorse/upload/fetch-upload-way',
            baseURL: baseURL,
            method: 'post',
            data: {file: fileProps},
            withCredentials: false,
            responseType: 'json',
            transformRequest: [function (data) {
                return instance.$qs.stringify(data);
            }],
            headers: {'X-Requested-With': 'XMLHttpRequest', 'Content-type': 'application/x-www-form-urlencoded'},
            onUploadProgress: function (progressEvent) {
                //console.log(progressEvent)
            }
        }).then(res => {
            //console.log(res);
            const status = res.data.status;
            const message = res.data.message;
            if (res && status == '1001') {
                const data = res.data.data;
                handle.resolve(data);
            } else {
                handle.reject(message);
            }
        }).catch(err => {
            handle.reject(err);
            instance.$message.error('Upload failed, please try again')
        });
    },
    
    // 上传至服务器
    
    uploadToS3: function (way, file, instance) {
        if (
        $.isPlainObject(way) &&
        way.hasOwnProperty('Key') &&
        way.hasOwnProperty('PutUrl') &&
        way['Key'] && way['PutUrl']
        ) {
            //console.log(way)
            const url = way['PutUrl'];
            const key = way['Key'];
            $.ajax({
                async: true,
                timeout: 30000,
                contentType: false,
                type: 'put',
                url: url,
                data: file,
                processData: false,
                success: function (res, status, success) {
                    if (success.readyState == 4 && success.status == 200) {
                        //console.log('success')
                        instance.db.form.file = key;
                        instance.conf.upload.update = true;
                    }
                },
                error: function (res, status, request) {
                },
                xhr: function () {
                    let xhr = $.ajaxSettings.xhr();
                    xhr.upload.onprogress = function (evt) {
                        
                        instance.conf.upload.showBar = true;
                        const isNewFile = instance.db.form.file ? false : true;
                        let loaded = Math.floor((evt.loaded / evt.total) * 100);
                        instance.conf.upload.percent = loaded;
                        if (loaded >= 100) {
                            instance.conf.upload.showBar = false;
                        } else {
                            instance.conf.upload.showBar = true;
                            instance.conf.upload.name = file.name;
                            //console.log("console-file", file)
                            if (isNewFile) {
                                instance.conf.upload.update = true;
                            }
                        }
                    };
                    return xhr;
                }
            });
        } else {
            instance.$message.error('Error getting upload information');
            return false;
        }
    }
    
};

export default upload;


// WEBPACK FOOTER //
// ./src/axios/upload.js